import { useMemo } from 'react'
import classes from './ChatWidget.module.scss'
import { isNumericColumn } from './dataTableService'
import { ChatTable } from './types'

interface Props {
  table: ChatTable
}

/**
 * Jenerik veri tablosu: özel kartı olmayan yapılandırılmış yanıtlar için (ör. cari ekstre).
 * Backend kolon başlıkları + satır dizileri gönderir; dar panelde yatay kaydırılır.
 */
export default function DataTable({ table }: Props) {
  // Tutar kolonları sağa yaslanır: basamaklar hizalanmadığında tablodaki rakamlar okunmuyor.
  const numericColumns = useMemo(
    () => table.columns.map((_, ci) => isNumericColumn(table.rows.map(row => row[ci] ?? ''))),
    [table]
  )

  // Gruplanan ilk kolonda tekrar eden değer gizlenir; grubun ilk satırı ayırıcı çizgiyle işaretlenir.
  const grouped = Boolean(table.groupFirstColumn)
  const isGroupStart = (ri: number) =>
    ri === 0 || (table.rows[ri]?.[0] ?? '') !== (table.rows[ri - 1]?.[0] ?? '')

  if (table.columns.length === 0 || table.rows.length === 0) return null

  return (
    <div className={classes.chatTableCard}>
      {table.title && <div className={classes.chatTableTitle}>{table.title}</div>}
      <div className={classes.chatTableWrap} tabIndex={0}>
        <table className={classes.chatTable}>
          <thead>
            <tr>
              {table.columns.map((column, i) => (
                <th key={i} className={numericColumns[i] ? classes.chatTableNumeric : undefined}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, ri) => (
              <tr key={ri} className={grouped && isGroupStart(ri) ? classes.chatTableGroupStart : undefined}>
                {table.columns.map((_, ci) => (
                  <td key={ci} className={numericColumns[ci] ? classes.chatTableNumeric : undefined}>
                    {ci === 0 && grouped && !isGroupStart(ri) ? '' : row[ci] ?? ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
